import { hotjarInit } from './lib/utils/hotjar';
import { Sentry } from '$lib/services/sentry';
import { getEnvironment } from '$lib/utils/environment';
import { getSentryConfig } from '$lib/services/sentry/config';
import { AppInitializationService } from '$lib/services/app-initialization';
import { initCrossTabLogoutListener } from '$lib/services/auth';

const environment = getEnvironment();

Sentry.init({
	...getSentryConfig({
		environment,
		// @ts-ignore
		release: __RELEASE_NAME__ || 'local',
		tracesSampleRate: 0.25,
	}),
	integrations: [
		Sentry.thirdPartyErrorFilterIntegration({
			filterKeys: ['testing-key'],
			behaviour: 'apply-tag-if-contains-third-party-frames',
		}),
	],
	allowUrls: [/https?:\/\/(?:www\.|web\.dev\.)?abcmouse\.com/],
});

export const handleError = Sentry.handleErrorWithSentry();

hotjarInit();

/**
 * Hook for client init
 */
export async function init() {
	initCrossTabLogoutListener();
	if (typeof navigator !== 'undefined' && navigator.userAgent.includes('isAutomatedTesting:true')) {
		window.addEventListener('e2e:sync-experiments-from-storage', async () => {
			const { setGlobalStore } = await import('$lib/stores/app/store.js');
			const stored = JSON.parse(localStorage.getItem('meta-app-store') ?? '{}');
			if (Array.isArray(stored.global?.experiments)) {
				await setGlobalStore({ experiments: stored.global.experiments });
			}
		});
	}
	await AppInitializationService.initialize();
}
